<template>
  <div class="bindCard">
    <div class="card-top">
      <div class="card-basic">
        <div class="card-basic-add">添加本人银行卡</div>
        <div class="card-basic-point">
          绑定银行卡，即可激活平安银行电子账户用于交易
        </div>
      </div>
      <van-form validate-first @submit="onDialogShow">
        <van-field
          label="用户姓名"
          placeholder="用户姓名"
          class="field-bottom"
          readonly
          :value="formData.userName"
        />
        <van-field
          label="身份证号"
          placeholder="身份证号"
          error-message-align="right"
          class="field-bottom"
          :value="formData.idNo"
          readonly
        />
        <van-field
          label="银行卡号"
          placeholder="银行卡号"
          :required="true"
          error-message-align="right"
          type="number"
          :rules="[
            { required: true, message: '银行卡号不能为空' },
            {
              pattern: /^\d{16,19}$/,
              message: '请填写正确的银行卡号',
              trigger: 'onBlur',
            },
          ]"
          class="field-bottom"
          v-model="formData.bankNo"
        />
        <van-field
          label="手机号"
          placeholder="手机号"
          :required="true"
          error-message-align="right"
          type="number"
          :rules="[
            { required: true, message: '手机号不能为空' },
            {
              pattern: /^1[0-9]{10}$/,
              message: '请填写正确的手机号',
              trigger: 'onBlur',
            },
          ]"
          v-model="formData.mobile"
        />

         <div class="card-bottom">
      <div class="crad-agreement">
        <div class="agreement">
          <div class="agreement-butt" v-if="type == 2">
            <van-checkbox
              v-model="checkedTop"
              icon-size="16px"
              class="agreement-check"
            ></van-checkbox>
            <span>同意<a @click="goPinaTreaty">《平安银行电子II、III类服务协议》</a></span>
          </div>
          <div class="agreement-treaty" v-if="type == 2">
            <van-checkbox
              v-model="checkedBottom"
              icon-size="16px"
              class="agreement-check"
            ></van-checkbox>
            <span>阅读同意<a @click="goPersonTreaty">《授权条款》</a></span>
          </div>
          <div class="agreement-treaty" v-if="type == 1">
            <van-checkbox
              v-model="checkedBottomPersion"
              icon-size="16px"
              class="agreement-check"
            ></van-checkbox>
            <span>阅读同意<a @click="goFreeTreaty">《自由职业者服务框架协议》</a></span>
          </div>
        </div>
      </div>
    </div>
    <div class="card-bind">
      <van-button
        block
        type="info"
        native-type="submit"
   
        >{{ type == 2 ? "同意协议并且绑卡" : "同意协议" }}</van-button
      >
    </div>
      </van-form>
    </div>

   
    <!-- 弹框 -->
    <van-overlay :show="bindShow">
      <div class="card-bind-wrapper" @click.stop>
        <div class="card-bind-block">
          <div class="bind-block-title">安全验证码</div>
          <div class="bind-block-detail">
            <div class="bind-block-detail-send">
              短信验证码会发送至您实名认证的手机
            </div>
            <div class="bind-block-detail-get">
              {{
                `${formData.mobile.slice(
                  0,
                  3
                )}****${formData.mobile.slice(7)}`
              }}，请注意查收
            </div>
          </div>
          <div class="bind-field-code">
            <van-field
              v-model="formData.smsCode"
              input-align="left"
              clearable
              center
              placeholder="请输入短信验证码"
              class="bink-field-input-back"
            >
              <template #button>
                <van-button
                  size="small"
                  type="primary"
                  class="bind-block-code"
                  @click="sendCode"
                  v-show="codeShow"
                  >发送验证码</van-button
                >
                <van-button
                  size="small"
                  type="primary"
                  class="bind-block-code"
                  :disabled="disCode"
                  @click="sendCode"
                  v-show="!codeShow"
                  >{{ count }}s</van-button
                >
              </template>
            </van-field>
          </div>

          <div class="bind-modify-submit">
            <div class="bind-modify" @click="backModify">返回</div>
            <div class="bind-modif-rightline"></div>
            <div class="bind-submit" @click="onSubmit">提交</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Steps from "./steps.vue";
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
  components: {
    Steps,
  },
  props: {
		type: {
			typeof: String,
			default: 0
		},
    authInfoVo: {
			typeof: Object,
			default: {},
		},
  },
  watch: {
    authInfoVo: {
      handler(old, cur) {
        const {idNo, userName} = this.authInfoVo
        this.formData.userName =userName;
        this.formData.idNo = idNo;
      }, 
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      checked: true,
      formData: {
        userName: "",
        idNo: "",
        bankNo: "",
        mobile: "",
        businessNo: "", // 业务请求流水号
        otpOrderNo: "", // otp流水号
        smsCode: "",
      },
			formCard:{
				bankAccount:"",
				bankShort:"",
			},
      checkedTop: true,
      checkedBottom: true,
			checkedBottomPersion:true,
      bindShow: false,
      codeShow: true,
      count: "",
      timer: null,
      disCode: false,
    };
  },

  methods: {
    goFreeTreaty(){
      this.$router.push({path:"../../freeTreaty"})
    },
    goPersonTreaty(){
      this.$router.push({path:"../../personTreaty"})
    },
    goPinaTreaty(){
      this.$router.push({path:"../../pinganTreaty"})
    },
		onValidateFailed(data) {
			this.$toast.fail('请检查表单输入!')
		},
    onDialogShow() {
				if (this.type ==2) {
					if(!this.checkedTop || !this.checkedBottom){
						this.$toast.fail("请先勾选协议")
            return false;
					}else{
						this.bindShow = true;
					}
			} else {
				if(!this.checkedBottomPersion){
					this.$toast.fail("请先勾选协议")
				}else{
					http.post(config.cardAuthInfo, this.formData).then(({code, data, message}) => {
					if (code === 0) {
						this.$toast.success('信息保存成功');
						this.$emit('onNextStep', 3)
					} else {
						this.$toast.fail(message);
					}
				})
					
				}	
				}
    },
    backModify() {
      this.bindShow = false;
    },
    onSubmit() {
			if(!this.formData.smsCode){
				this.$toast.fail('请输入短信验证码')
				return false
			} else{
				const {bankNo, mobile} = this.formData;
				if (!bankNo || !mobile) {
					this.$toast.fail('银行卡号，手机号不能为空')
					return false
				}
				http.post(config.openAccount, this.formData).then(({ code,message, data }) => {
          if(code===0){
            if(data.code===200){
            this.$toast.success("银行卡验证成功")
         	  this.formCard.bankAccount=data.bankAccount;//银行名称
						this.formCard.bankShort=data.bankShort;//银行卡号
						this.$emit('onNextStep', 3,this.formCard) // 跳转到后面的电子账户 银行二类户账号bankAccount	
            }else{
              this.$toast.fail(data.message)

            }
          }else{
            this.$toast.fail(message)
          }
        	// if (code === 0 && data.code == 200) {
        	//   this.$toast.success("银行卡验证成功")
         	//   this.formCard.bankAccount=data.bankAccount;//银行名称
					// 	this.formCard.bankShort=data.bankShort;//银行卡号
					// 	this.$emit('onNextStep', 3,this.formCard) // 跳转到后面的电子账户 银行二类户账号bankAccount			
        	// }else{
					// 	this.$toast.fail(message)
					// }
      	});
			}
    },
    sendCode() {
      http.post(config.sendSms, this.formData).then(({ code, data }) => {
        if (code === 0 && data.code == 200) {
          this.timerFun();
          this.formData.businessNo = data.businessNo;
          this.formData.otpOrderNo = data.otpOrderNo;
        } else {
					this.$toast.fail(data.message)
				}
      });
    },
    timerFun() {
      // 倒计时
      this.disCode = true;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
  }
};
</script>
<style>
.bindCard .van-field--error .van-field__control,
.van-field--error .van-field__control::placeholder {
  color: #cbcccf;
}
</style>

<style lang="less">
.bindCard input.van-field__control {
  text-align: right;
}
.field-bottom {
  margin-bottom: 40px;
}
.bindCard .van-cell__value--alone{
  text-align: left;
}
.bindCard .bind-field-code input.van-field__control {
  text-align: center;
}
</style>

<style lang="less" scoped>
.van-field__button {
  margin-right: -14px;
}
.bindCard {
  .card-header {
    position: relative;
    height: 285px;
    //   渐变色
    background: linear-gradient(117deg, #0681fd 0%, #0178f2 100%);
    .iconzuojiantou {
      position: absolute;
      left: 30px;
    }
    span {
      font-size: 32px;
      color: #fff;
    }
    .header-top {
      height: 80px;
    }
  }

  .card-top {
    padding: 30px;
    .card-basic {
      text-align: left;
      margin-bottom: 40px;
      .card-basic-add {
        font-size: 32px;
        color: #222222;
        margin-bottom: 10px;
      }
      .card-basic-point {
        font-size: 24px;
        color: #999999;
      }
    }
    .card-line {
      width: 100%;
      height: 1px;
      background: #ececec;
      margin: 30px 0;
    }
    .card-user {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .card-user-name-common {
        color: #333333;
        font-size: 30px;
        line-height: 44px;
      }
      .card-user-name-common {
      }
    }
  }
  .card-bottom {
    .crad-agreement {
      width: 100%;
      height: 310px;
      // background: #f8f8fa;
      .agreement {
        padding: 66px 30px;
        span {
          color: #8e8e8e;
          a {
            color: #3083ff;
          }
        }
        .agreement-butt {
          text-align: left;
          margin-bottom: 20px;
          .agreement-check {
            float: left;
            margin-right: 10px;
          }
        }
        .agreement-treaty {
          text-align: left;
          .agreement-check {
            float: left;
            margin-right: 10px;
          }
        }
      }
    }
  }
  .card-bind {
    position: fixed;
    bottom: 0;
    left:0;
    width: 100%;
    .card-bind-card {
      width: 100%;
      border-radius: 0;
    }
  }
  .card-bind-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .card-bind-block {
    width: 90%;
    height: 490px;
    background-color: #fff;
    border-radius: 10px;
    padding: 30px;
    box-sizing: border-box;
    .bind-block-title {
      font-size: 32px;
      color: #333333;
      margin-bottom: 20px;
      font-weight: 500;
    }
    .bind-block-detail {
      color: #666666;
      font-size: 28px;
      margin-bottom: 60px;
      .bink-block-detail-send {
      }
      .bink-block-detail-get {
      }
    }
    .bind-field-code {
      .bind-block-code {
        width: 180px;
        height: 74px;
        background: #4da5ff;
        border: none;
        border-radius: 45px;
        height: 90px;
        margin-right: -25px;
      }
      .bink-field-input-back {
        background: rgba(6, 129, 253, 0.04);
        border-radius: 45px;
        height: 90px;
      }
    }
    .bind-modif-rightline {
      height: 100px;
      width: 1px;
      background: #ececec;
    }
    .bind-modify-submit {
      width: 100%;
      height: 100px;
      border-top: 1px solid #ececec;
      font-size: 34px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 60px;
      .bind-submit {
        color: #0681fd;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/commonInfo/components/bindCard.vue